import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SafeHtmlPipe } from '@finder/shared/utils/pipes/safe-html/safe-html.pipe';

const unknownError = 0;

@Component({
    selector: 'finder-system-error',
    templateUrl: './system-error.component.html',
    styleUrls: ['./system-error.component.scss'],
    imports: [
        CommonModule,
        SafeHtmlPipe
    ]
})
export class SystemErrorComponent {

    @Input() status: number;
    @Input() bundle: any;
    unknown = unknownError;

    constructor() { }

}
